import subMonths from 'date-fns/subMonths'
import { ContractorSensor, ProjectSectionSensor, Sensor } from 'src/api'

export const ACTIVATED_HIGHLIGHT_MONTHS = 24
export const LAST_PING_WARNING_MONTHS = 3
export const LAST_PING_ALERT_MONTHS = 6

export const activatedHighlightColor = '#2e7d32'
export const lastPingWarningColor = '#D0CA2F'
export const lastPingAlertColor = '#ff5c64'

export const isOlderThanMonths = (value: string | null | undefined, months: number): boolean => {
  if (!value) return false
  const date = new Date(value)
  if (isNaN(date.getTime())) return false
  return date.getTime() <= subMonths(new Date(), months).getTime()
}

export const getActivationDateColor = (value: string | null | undefined): string | undefined =>
  isOlderThanMonths(value, ACTIVATED_HIGHLIGHT_MONTHS) ? activatedHighlightColor : undefined

export const getLastPingColor = (value: string | null | undefined): string | undefined => {
  if (isOlderThanMonths(value, LAST_PING_ALERT_MONTHS)) return lastPingAlertColor
  if (isOlderThanMonths(value, LAST_PING_WARNING_MONTHS)) return lastPingWarningColor
  return undefined
}

export const getActiveContractorSensor = (sensor?: Sensor): ContractorSensor | null =>
  (sensor?.contractorSensors || []).filter((cs) => cs.isActive).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0] || null

export const getActiveProjectSectionSensor = (sensor?: Sensor): ProjectSectionSensor | null => sensor?.projectSectionsSensors?.find((pss) => pss.isActive) || null
